module.exports = __webpack_public_path__ + "static/media/mt.51f074ae.svg";